// RSA-OAEP encryption for secure card data transmission
// Card data is encrypted in the browser before being sent to the server
// Only the private key holder can decrypt the data

const PUBLIC_KEY_B64 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAs3Pkm3RchlvRcg/ruKbkzzzLcT83n9QTYW8UFG2MT/1FR6darZbLw39ZhqEwoP8AlyjmJA4UFSOw472XjsLa7KDe3wDkKaLZjU5StslD5kIHE6Dc/Jc6kCpUQZdFvY7idpx2mlmNzYsjVUoMSyuMPqxChZ+PshgMj97lvZHSxK7rnFncwAVW9rPRE96MfcBFy8lA+GKWhzfyK8xDYjQZ4zWyWZi9JfpLqR9R9o7kMkT+yBEdgRanpSE/NIXN5TJPGI+vkmCFGKFTSoKost2c4eegPPE1Mrb3dYwVeDAYBTmJOVkG2kJITqK0zJnISamumyQE/T8EKN/Fg5/tlRlS2wIDAQAB';

function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export async function encryptCardData(cardData) {
  const publicKeyBuffer = base64ToArrayBuffer(PUBLIC_KEY_B64);

  const publicKey = await window.crypto.subtle.importKey(
    'spki',
    publicKeyBuffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  );

  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(cardData));

  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    data
  );

  return arrayBufferToBase64(encrypted);
}
